import { useAxiosStore } from '@risksmart-app/components/src/hooks/useAxios';

import { handleError } from '@/utils/errorUtils';

type Response = { returnedText: string };

export const usePostInferenceCommand = () => {
  const { authorisedAxiosInstance } = useAxiosStore();

  return async (prompt: string, bodyText: string): Promise<Response> => {
    try {
      const { data } = await authorisedAxiosInstance.post<Response>(
        '/bedrock',
        {
          prompt: prompt,
          bodyText: bodyText,
        }
      );

      if (data.returnedText) {
        return data;
      } else {
        handleError(new Error('No returned text'));

        throw new Error('No returned text');
      }
    } catch (error) {
      handleError(new Error(`Something went wrong! ${error}`));

      throw new Error(`Something went wrong! ${error}`);
    }
  };
};
